import { apiClient } from "@nabble/sdk";
import type { DataRequestKind, DataRequestStatus } from "./dataRequests";

/** A person's personal data request, as the Admin Center sees it (open ones first, by deadline). */
export interface AdminDataRequest {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  kind: DataRequestKind;
  details: string | null;
  status: DataRequestStatus;
  createdAt: string;
  dueAt: string;
  overdue: boolean;
  extended: boolean;
  extensionReason: string | null;
  resolution: string | null;
  resolvedAt: string | null;
}

export function fetchAdminDataRequests(): Promise<AdminDataRequest[]> {
  return apiClient<AdminDataRequest[]>("/api/admin/data-requests");
}

/** IN_PROGRESS needs no resolution; DONE and REJECTED do, and the person receives it by email. */
export function updateDataRequest(id: string, status: Exclude<DataRequestStatus, "OPEN">, resolution: string): Promise<void> {
  return apiClient<void>(`/api/admin/data-requests/${id}`, { method: "PUT", body: { status, resolution } });
}

/** Adds 30 days to the deadline, once; the person receives the reason by email. */
export function extendDataRequest(id: string, reason: string): Promise<void> {
  return apiClient<void>(`/api/admin/data-requests/${id}/extend`, { method: "POST", body: { reason } });
}
